import WaterLevel from '../../../components/Sensor/WaterLevel'
import WaterMeterChart from '../../../components/Sensor/WaterMeter'
import { HiCube } from 'react-icons/hi'

const FuelLevel1 = ({ dataSource }) => {
    const [dataLevel] = dataSource.items;

    return (
        <div className="bg-white/80 backdrop-blur-sm rounded-2xl shadow-lg border border-white/20 p-6">
            <div className="flex items-center space-x-3 mb-4">
                <div className="w-8 h-8 bg-blue-500/20 rounded-lg flex items-center justify-center">
                    <HiCube className="w-4 h-4 text-blue-600" />
                </div>
                <div>
                    <h3 className="text-lg font-semibold text-gray-900">{dataSource.groupName}</h3>
                    <p className="text-sm text-gray-600">Tank capacity monitoring</p>
                </div>
            </div>

            <div className="flex flex-col w-full rounded gap-2 bg-white p-4">
                <div className="flex flex-col lg:flex-row justify-evenly items-center gap-6">
                    <WaterLevel dataSource={dataLevel} />
                    <WaterMeterChart dataSource={dataLevel} />
                </div>
            </div>

        </div>


    )
}

export default FuelLevel1